/*
 * NOTE: THIS FILE IS A WELL STRUCTURED MESS DO NOT ATTEMPT TO REFACTOR THIS
 *
 * This file ports over the typography LESS file from CORE-UI.
 */
import { createGlobalStyle, css } from 'styled-components';
import { pxToRem } from '../style-utilities';
import { ANWBDefault } from './anwb-default';
const TARGET_PX_SIZE = 16;
const BLUE = 'hsla(199, 100%, 43%, 1)';
const BLUE_GREY = 'hsla(203, 54%, 84%, 1)';
const BLUE_GREY_LIGHT = 'hsla(202, 53%, 90%, 1)';
const BLUE_GREY_DARK = 'hsla(204, 44%, 55%, 1)';
const BLUE_GREY_DARKER = '#003D86';
const BLUE_DARK = 'hsla(213, 100%, 26%, 1)';
const FONT_SIZE = '1em';
const UI_ICONS_FONT = 'ui-icons';
const UI_FILL_ICONS_FONT = 'ui-fill-icons';
const ILLUSTRATIVE_ICONS_FONT = 'illustrative-icons';
const FALLBACK_FONT = `Arial, sans-serif, ${UI_ICONS_FONT}, ${UI_FILL_ICONS_FONT}, ${ILLUSTRATIVE_ICONS_FONT}`;
const DEFAULT_FONTS = `Verdana, ${FALLBACK_FONT}`;
const ANWB_FONT = 'AnwbTheSans';
const ANWB_FONT_FAMILY = `${ANWB_FONT}, ${FALLBACK_FONT}`;
const ANWB_FONT_FAMILY_DEFAULT = 'Bernina Sans';
const LINE_HEIGHT_BASE = 1.5;
const LINE_HEIGHT_S = 1.2;
const MAX_TEXT_WIDTH = '46.875rem';
const REM_UNIT = TARGET_PX_SIZE / 3;
const REM = REM_UNIT * 3;
const REM_XS = REM_UNIT;
const GRID_BASE = REM_UNIT * 1.2;
const VIEWPORT_M = '37.5em';
const VIEWPORT_L = '64em';
const BREAKPOINT_M = `min-width: ${VIEWPORT_M}`;
const BREAKPOINT_L = `min-width: ${VIEWPORT_L}`;
const HEADING_XL = pxToRem(36);
const HEADING_L = pxToRem(28);
const HEADING_M = pxToRem(24);
const HEADING_S = pxToRem(18);
const FONT_SIZE_S = pxToRem(14).replace('rem', 'em');
const MARGIN_TEXT_S = pxToRem(6);
const MARGIN_TEXT_M = pxToRem(10);
const MARGIN_TEXT_L = pxToRem(16);
const MARGIN_TEXT_XL = pxToRem(24);
const MARGIN_TEXT_NEGATIVE_S = pxToRem(-6);
const MARGIN_TEXT_NEGATIVE_M = pxToRem(-12);
const MARGIN_TEXT_NEGATIVE_L = pxToRem(-14);
const OFFSET_L = GRID_BASE * 2.66666666666666;
const LINE = '2px';
const hyphenate = () => css `
	hyphens: auto;
	/* prevent faulty hyphens by using supports for the fallback */
	@supports not (hyphens: auto) {
		word-break: break-word;
	}
`;
const anwbTheSansBold = () => css `
	font-family: ${ANWB_FONT_FAMILY};
	font-style: normal;
	font-weight: bold;
`;
const anwbTheSansBoldItalic = () => css `
	font-family: ${ANWB_FONT_FAMILY};
	font-style: italic;
	font-weight: bold;
`;
const typographicMargin = () => css `
	margin-top: ${MARGIN_TEXT_L};
	margin-bottom: ${MARGIN_TEXT_L};
	max-width: ${MAX_TEXT_WIDTH};

	@media (${BREAKPOINT_M}) {
		margin-bottom: ${MARGIN_TEXT_XL};
	}
`;
const shouldApplyFontStyles = (theme) => theme.name === ANWBDefault.name;
export const legacyGlobalTypographyStyles = ({ theme }) => css `
	/**
	 * Basic foundation for typography for the anwb website to build upon.
	 */

	/**
	 * box-sizing ftw
	 */

	*,
	*:before,
	*:after {
		box-sizing: inherit;
	}

	/**
	 * Main selectors
	 */

	html {
		box-sizing: border-box;
		-ms-text-size-adjust: 100%;
		-webkit-text-size-adjust: 100%;
	}

	body {
		margin: 0;
		overflow-x: hidden;
		-moz-osx-font-smoothing: grayscale;
		-webkit-font-smoothing: antialiased;
		line-height: ${LINE_HEIGHT_BASE};
		font-family: ${ANWB_FONT_FAMILY_DEFAULT};
		color: ${theme.colors.base.textBody};

		${shouldApplyFontStyles(theme) &&
    css `
			color: ${BLUE_GREY_DARKER};
			font-size: ${FONT_SIZE};
			font-family: ${DEFAULT_FONTS};
		`}
	}

	/**
	 * Heading selectors (h1-h3)
	 */
	${shouldApplyFontStyles(theme) &&
    css `
		h1,
		h2,
		h3,
		h4,
		h5,
		h6 {
			line-height: ${LINE_HEIGHT_S};
		}
	`}

	h1,
	h2,
	h3,
	h4,
	h5,
	h6,
	th {
		margin-top: 0;
		max-width: ${MAX_TEXT_WIDTH};
		text-rendering: optimizeLegibility;

		${shouldApplyFontStyles(theme) &&
    css `
			color: ${BLUE_DARK};

			${hyphenate()};

			@media (${BREAKPOINT_L}) {
				// Prevent hyphenation on large breakpoint
				word-break: normal;
				hyphens: none;
			}
		`}
	}

	h1 {
		margin-bottom: ${MARGIN_TEXT_S};
		max-width: none;

		@media (${BREAKPOINT_M}) {
			margin-bottom: ${MARGIN_TEXT_M};
		}

		${shouldApplyFontStyles(theme) &&
    css `
			${anwbTheSansBoldItalic};
			font-size: ${HEADING_L};

			@media (${BREAKPOINT_M}) {
				font-size: ${HEADING_XL};
				margin-bottom: ${MARGIN_TEXT_M};
			}

			@media (${BREAKPOINT_L}) {
				font-size: ${HEADING_XL};
			}
		`}

		+ p,
		+ ol,
		+ ul {
			margin-top: ${MARGIN_TEXT_L};

			@media (${BREAKPOINT_M}) {
				margin-top: ${MARGIN_TEXT_XL};
			}
		}
	}

	h2 {
		margin-bottom: ${MARGIN_TEXT_M};

		@media (${BREAKPOINT_M}) {
			margin-bottom: ${MARGIN_TEXT_L};
		}

		${shouldApplyFontStyles(theme) &&
    css `
			${anwbTheSansBold()};
			font-size: ${HEADING_M};
		`}
	}

	h3,
	h4 {
		margin-bottom: ${MARGIN_TEXT_M};

		@media (${BREAKPOINT_M}) {
			margin-bottom: ${MARGIN_TEXT_L};

			+ small {
				margin-top: -${MARGIN_TEXT_S};
			}
		}

		${shouldApplyFontStyles(theme) &&
    css `
			${anwbTheSansBold()};
			font-size: ${HEADING_S};
		`}
	}

	h5,
	h6 {
		margin-bottom: ${MARGIN_TEXT_M};

		@media (${BREAKPOINT_M}) {
			margin-bottom: ${MARGIN_TEXT_L};

			+ small {
				margin-top: -${MARGIN_TEXT_S};
			}
		}

		${shouldApplyFontStyles(theme) &&
    css `
			${anwbTheSansBold()};
			font-size: ${MARGIN_TEXT_L};
		`}
	}

	a {
		color: ${theme.colors.highlight.textLink};

		&:hover {
			color: ${theme.colors.base.textBodyLinkHover};
		}
	}

	${shouldApplyFontStyles(theme) &&
    css `
		small {
			font-size: ${FONT_SIZE_S};
			color: ${BLUE_GREY_DARK};
			line-height: ${LINE_HEIGHT_BASE};
		}
	`}

	// required by Xinha editor
	.nobr {
		white-space: nowrap;
	}

	// paragraph settings
	p,
	ol,
	ul {
		${typographicMargin};
	}

	// legend settings
	legend {
		padding-left: 0;
	}

	h2 {
		+ p,
		+ ol,
		+ ul {
			margin-top: ${MARGIN_TEXT_NEGATIVE_S};

			@media (${BREAKPOINT_M}) {
				margin-top: ${MARGIN_TEXT_NEGATIVE_M};
			}
		}
	}

	h3,
	h4,
	h5,
	h6 {
		+ p,
		+ ol,
		+ ul {
			margin-top: ${MARGIN_TEXT_NEGATIVE_S};

			@media (${BREAKPOINT_M}) {
				margin-top: ${MARGIN_TEXT_NEGATIVE_L};
			}
		}
	}

	b,
	strong {
		max-width: ${MAX_TEXT_WIDTH};

		${shouldApplyFontStyles(theme) &&
    css `
			font-weight: bold;
		`}
	}

	::-moz-selection {
		background: ${BLUE_GREY_LIGHT};
		text-shadow: none;
	}

	::selection {
		background: ${BLUE_GREY_LIGHT};
		text-shadow: none;
	}

	h3 + ul,
	small + ul {
		margin-top: ${REM_XS};
	}

	.subtitle {
		&: extend(h3);

		${shouldApplyFontStyles(theme) &&
    css `
			color: ${BLUE};
		`}
	}

	.summary {
		margin-top: 0;

		${shouldApplyFontStyles(theme) &&
    css `
			color: ${BLUE};

			& time {
				font-style: italic;
			}
		`}
	}

	.mainsummary {
		margin-top: ${OFFSET_L};
	}

	// moved from initialized
	audio,
	canvas,
	progress,
	video {
		vertical-align: baseline;
	}

	abbr[title] {
		border-bottom: ${LINE} dotted;
	}

	${shouldApplyFontStyles(theme) &&
    css `
		dfn {
			font-style: italic;
		}

		small {
			font-size: 80%;
		}
	`}

	sub,
	sup {
		position: relative;
		vertical-align: baseline;

		${shouldApplyFontStyles(theme) &&
    css `
			font-size: 75%;
			line-height: 0;
		`}
	}

	sup {
		top: -0.5em;
	}

	sub {
		bottom: -0.25em;
	}

	${shouldApplyFontStyles(theme) &&
    css `
		code,
		kbd,
		pre,
		samp {
			font-family: monospace, monospace;
			font-size: 1em;
		}
	`}

	pre {
		overflow: auto;
	}

	hr {
		display: block;
		height: ${LINE};
		border: 0;
		border-top: ${LINE} solid ${BLUE_GREY};
		margin: ${REM} 0;
		padding: 0;
	}

	audio,
	canvas,
	iframe,
	img,
	svg,
	video {
		vertical-align: middle;
	}

	details,
	summary {
		display: block;
	}

	// Added because page-title should have a default color
	[data-variant='page-title'] {
		color: ${theme.colors.base.textTitles};
	}
`;
/**
 * This component creates a Styled Components global style
 * which contains the old CORE-UI global typography styles.
 * You can either load this component or directly place
 * load the generated styles in your project */
export const LegacyGlobalTypography = createGlobalStyle `
	${legacyGlobalTypographyStyles}
`;
